import { AdviseEngagement } from '../../../types/advise';
import { hasAdviseFull } from '../../../store/User';

// The store holds the previous engagement while the next loads; a missing can_edit comes from a PUT, which only an editor sends.
export const canEditEngagement = (engagement: AdviseEngagement | null, requestedId: string | null): boolean =>
  hasAdviseFull() && !!engagement && engagement.id === requestedId && engagement.can_edit !== false;
